import { useRouteLoaderData } from '@remix-run/react'
import { type RootLoaderData, type loader as rootLoader } from '#app/root.tsx'

function isUser(user: any): user is {
	image: {
		id: string
	} | null
	id: string
	username: string
	name: string | null
	ownGroups: {
		image: {
			id: string
		} | null
		id: string
		name: string
	}[]
	groups: {
		image: {
			id: string
		} | null
		id: string
		name: string
	}[]
	roles: {
		name: string
	}[]
} | null {
	return user && typeof user === 'object' && typeof user.id === 'string'
}

export function useOptionalUser() {
	const data = useRouteLoaderData<typeof rootLoader>('root') as
		| RootLoaderData
		| undefined
	if (!data || !isUser(data.user)) {
		return undefined
	}
	return data.user
}

export function useUser() {
	const maybeUser = useOptionalUser()
	if (!maybeUser) {
		throw new Error(
			'No user found in root loader, but user is required by useUser. If user is optional, try useOptionalUser instead.',
		)
	}
	return maybeUser
}

export function userHasRole(
	user: Pick<ReturnType<typeof useUser>, 'roles'> | null,
	role: string,
) {
	if (!user) return false
	return user.roles.some((r) => r.name === role)
}

export function userIsGroupCoach(
	user: Pick<ReturnType<typeof useUser>, 'id'> | null | undefined,
	coaches: Array<{ id: string }>,
) {
	if (!user) return false
	return coaches.some((c) => c.id === user.id)
}

export function useDisabledRoles(): string[] {
	const data = useRouteLoaderData<typeof rootLoader>('root') as
		| RootLoaderData
		| undefined
	return data?.disabledRoles ?? []
}
